module.exports = __webpack_public_path__ + "static/img/1bac.2435ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/1bac.jpg
// module id = Zk2D
// module chunks = 1